import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import { DiagnosisCustomerSitesReadDTO, DiagnosisCustomerSitesCreateDTO } from '../generated/api-client';

export const useDiagnosisCustomerSites = () => {
  return useQuery<DiagnosisCustomerSitesReadDTO[]>('diagnosisCustomerSites', () => apiClient.list_items_diagnosis_customer_sites__get());
};

export const useDiagnosisCustomerSitesById = (id: string) => {
  return useQuery<DiagnosisCustomerSitesReadDTO>(
    ['diagnosisCustomerSites', id],
    () => apiClient.get_item_diagnosis_customer_sites__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useDiagnosisCustomerSitesByCustomerId = (customerId: string) => {
  return useQuery<DiagnosisCustomerSitesReadDTO[]>(
    ['diagnosisCustomerSites', 'byCustomerId', customerId],
    () => apiClient.search_by_customer_id_diagnosis_customer_sites_search_by_customer_id__customer_id__get(customerId),
    {
      enabled: !!customerId,
    }
  );
};

export const useCreateDiagnosisCustomerSites = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisCustomerSitesReadDTO, Error, DiagnosisCustomerSitesCreateDTO>(
    (data) => apiClient.create_item_diagnosis_customer_sites__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisCustomerSites');
      },
    }
  );
};

export const useUpdateDiagnosisCustomerSites = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisCustomerSitesReadDTO, Error, { id: string; data: DiagnosisCustomerSitesCreateDTO }>(
    ({ id, data }) => apiClient.update_item_diagnosis_customer_sites__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisCustomerSites');
      },
    }
  );
};

export const useDeleteDiagnosisCustomerSites = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    (id) => apiClient.delete_item_diagnosis_customer_sites__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisCustomerSites');
      },
    }
  );
};

